import TripIncidentsList from './TripIncidentsList';

export default TripIncidentsList;
